<ng-container *ngIf="state?.hits as hits">
    <ng-container *ngIf="hits | asAlgoliaDealer : true | transformDealer as markers">
        <app-grid>
            <app-cell mobile="full:full">
                <app-google-maps [options]="mapOptions"
                                 [locationMarkers]="markers"
                                 [showFilter]="true"
                                 [filterCount]="filterCount"
                                 (filterClick)="filterClick()"
                ></app-google-maps>

                <div hidden>
                    <app-refinement-list attribute="types"
                                         operator="and"
                                         [localisedAttribute]="'dealers.dealer-type' | translate"
                    ></app-refinement-list>

                    <app-refinement-list attribute="brands"
                                         operator="or"
                    ></app-refinement-list>
                </div>
            </app-cell>
        </app-grid>
    </ng-container>
</ng-container>
